import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
import Followers from "@/views/Follow/Follow.vue";
import Likes from "@/views/Like/Like.vue";
import CoinStore from "@/views/Coin/CoinStore.vue";
import Coins from "@/views/Coin/index.vue";
import More from "@/views/More/More.vue";
import Splash from "@/views/Splash/Splash.vue";
import EarnCoin from "@/views/EarnCoin/EarnCoin.vue";

const Login = () => import("@/views/Login/Login.vue");
const ChallengeRequire = () =>
  import("@/views/Login/ChallengeRequire/ChallengeRequire.vue");

const TwoFactorSecurityCode = () =>
  import("@/views/Login/TwoFactorSecurityCode/TwoFactorSecurityCode.vue");
const ManageAccount = () => import("@/views/ManageAccount/ManageAccount.vue");
const VipDiscount = () => import("@/views/VipDiscount/VipDiscount.vue");
const VipPage = () => import("@/views/VipPlan/VipPage.vue");
const Payment = () => import("@/views/Payment/Payment.vue");
const OrderDetail = () => import("@/views/OrderDetail/OrderDetail.vue");

const Setting = () => import("@/views/Setting/Setting.vue");
const SettingPrivacy = () => import("@/views/Setting/SettingPrivacy.vue");
const SettingTerm = () => import("@/views/Setting/SettingTerm.vue");
const Faqs = () => import("@/views/Faqs/Faqs.vue");
const Orders = () => import("@/views/Orders/Orders.vue");
// const SuperPayPopup = () => import("@/views/SuperPayPopup/SuperPayPopup.vue");
// const SuperPayReceive = () => import("@/views/superPayReceive/index.vue");
const DoubleCoins = () => import("@/views/DoubleCoins/DoubleCoins.vue");
const ChallengePage = () => import("@/views/Login/ChallengePage/index.vue");

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/Home",
      name: "Home",
      component: Home,
      redirect: "/Home/Followers",
      children: [
        {
          path: "Followers",
          name: "Followers",
          component: Followers
        },
        {
          path: "Likes",
          name: "Likes",
          component: Likes
        },
        {
          path: "Earns",
          name: "Earns",
          component: EarnCoin
        },
        {
          path: "Coins",
          name: "Coins",
          component: Coins
        },
        {
          path: "More",
          name: "More",
          component: More
        }
      ]
    },
    {
      path: "/Login",
      name: "Login",
      component: Login
    },
    {
      path: "/ChallengeRequire",
      name: "ChallengeRequire",
      component: ChallengeRequire
    },
    {
      path: "/TwoFactorSecurityCode",
      name: "TwoFactorSecurityCode",
      component: TwoFactorSecurityCode
    },
    {
      path: "/Splash",
      name: "Splash",
      component: Splash
    },
    {
      path: "/ManageAccount",
      name: "ManageAccount",
      component: ManageAccount
    },
    {
      path: "/VipPage",
      name: "VipPage",
      component: VipPage
    },
    {
      path: "/VipDiscount",
      name: "VipDiscount",
      component: VipDiscount
    },
    {
      path: "/CoinStore",
      name: "CoinStore",
      component: CoinStore
    },
    {
      path: "/Payment",
      name: "Payment",
      component: Payment
    },
    {
      path: "/OrderDetail",
      name: "OrderDetail",
      component: OrderDetail
    },
    {
      path: "/Setting",
      name: "Setting",
      component: Setting
    },
    {
      path: "/SettingPrivacy",
      name: "SettingPrivacy",
      component: SettingPrivacy
    },
    {
      path: "/SettingTerm",
      name: "SettingTerm",
      component: SettingTerm
    },
    {
      path: "/Faqs",
      name: "Faqs",
      component: Faqs
    },
    {
      path: "/Orders",
      name: "Orders",
      component: Orders
    },
    // {
    //   path: "/SuperPayPopup",
    //   name: "SuperPayPopup",
    //   component: SuperPayPopup
    // },
    {
      path: "/DoubleCoins",
      name: "DoubleCoins",
      component: DoubleCoins
    },
    {
      path: "/ChallengePage",
      name: "ChallengePage",
      component: ChallengePage
    }
  ]
});

// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;

// push
Router.prototype.push = function push(location: any): any {
  return (originalPush.call(this, location) as any).catch(() => {
    //
  });
};
// replace
Router.prototype.replace = function push(location: any): any {
  return (originalReplace.call(this, location) as any).catch(() => {
    //
  });
};
